import { useEffect, useState } from "react";
import { Navbar } from "@/components/portfolio/Navbar";
import { Hero } from "@/components/portfolio/Hero";
import { About } from "@/components/portfolio/About";
import { Experience } from "@/components/portfolio/Experience";
import { Education } from "@/components/portfolio/Education";
import { Skills } from "@/components/portfolio/Skills";
import { Activities } from "@/components/portfolio/Activities";
import { Honors } from "@/components/portfolio/Honors";
import { Gallery } from "@/components/portfolio/Gallery";
import { Contact } from "@/components/portfolio/Contact";

export default function Portfolio() {
  const [dark, setDark] = useState(() => (localStorage.getItem("theme") || "light") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <div className="portfolio-root min-h-screen" data-testid="portfolio-page">
      <Navbar dark={dark} onToggleTheme={() => setDark((d) => !d)} />
      <main>
        <Hero />
        <About />
        <Experience />
        <Education />
        <Skills />
        <Activities />
        <Honors />
        <Gallery />
        <Contact />
      </main>
    </div>
  );
}
